import React, { useEffect, useRef, useState } from "react";
import PDFObject from "pdfobject";

interface PDFViewerProps {
  pdf_url: string;
  containerStyle?: Record<string, any>;
}

const PDFViewer: React.FC<PDFViewerProps> = ({
  pdf_url,
  containerStyle = {},
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    if (pdf_url && containerRef.current) {
      const iframe = PDFObject.embed(
        pdf_url,
        containerRef.current
      ) as HTMLIFrameElement;

      // Listen for iframe load
      if (iframe) {
        iframe.style.display = "none"; // hide until loaded
        iframe.addEventListener("load", () => {
          setLoading(false);
          iframe.style.display = "block";
        });
      }
    }
  }, [pdf_url]);

  return (
    <div style={{ position: "relative" }}>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fff",
            zIndex: 10,
          }}
        >
          <span>Loading PDF…</span>
        </div>
      )}

      <div
        ref={containerRef}
        style={{
          width: "100%",
          height: "600px",
          border: "1px solid #ccc",
          ...containerStyle,
        }}
      >
        PDF preview not available.
      </div>
    </div>
  );
};

export default PDFViewer;
